var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2344,
    height: 231,
    viewBox: "0 0 2344 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2344,
    height: 231
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H2343.5V231H0.5V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2809 766C2809 1189.05 2075.64 1532 1171 1532C266.358 1532 -467 1189.05 -467 766C-467 342.95 266.358 0 1171 0C2075.64 0 2809 342.95 2809 766Z",
    fill: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2809 766C2809 1189.05 2075.64 1532 1171 1532C266.358 1532 -467 1189.05 -467 766C-467 342.95 266.358 0 1171 0C2075.64 0 2809 342.95 2809 766Z",
    stroke: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackFooter);
export default __webpack_public_path__ + "static/media/back-footer.8a7ea903a6c366cd6ce61b4d5b7f555e.svg";
export { ForwardRef as ReactComponent };